import { Box, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import type {
  PolymorphicLinkProps,
  PolymorphicTypographyProps,
} from "../../types";

const TABLET_BREAKPOINT = 640;

export const Heading = styled(Typography)<PolymorphicTypographyProps>(
  ({ theme }) => ({
  fontSize: 11,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  lineHeight: 1.3,
  margin: "0 0 18px",
  color: theme.palette.text.secondary,
}));

export const Grid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: 20,
  rowGap: 4,
  [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
    gridTemplateColumns: "1fr",
  },
}));

export const CategoryLink = styled(Link)<PolymorphicLinkProps>(({ theme }) => ({
  display: "block",
  marginBottom: 14,
  textDecoration: "none",
  transition: theme.transitions.create("opacity", { duration: 160 }),
  "&:hover": {
    opacity: 0.7,
  },
}));

export const Name = styled("span")(({ theme }) => ({
  display: "block",
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.3,
  color: theme.palette.text.primary,
}));

export const Sub = styled("span")(({ theme }) => ({
  display: "block",
  fontSize: 11.5,
  marginTop: 1,
  color: theme.palette.text.disabled,
}));
